module.exports = __webpack_public_path__ + "img/dock.ec35ff22.png";